import { ColumnType } from '../components/Kanban2/type'

type SelectOption = {
  label: string
  value: string
}

const getContractFromColumn = (column: ColumnType): SelectOption[] => {
  if (!column.cardList) return []

  return column.cardList
    .map((card) => card.tags?.[0]?.value)
    .filter((value): value is string => Boolean(value)) // remove undefined/null/empty
    .map((value) => {
      const words = value.trim().split(/\s+/)
      const lastTwo = words.slice(-2).join(' ')
      return {
        label: lastTwo,
        value,
      }
    })
}

export default getContractFromColumn
